module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa role",
      "breadcrumbs": [{
        title: 'Quản lý role',
        route: {
          name: 'role'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "createRoleForm",
    attrs: {
      "model": _vm.localRole,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitRole('createRoleForm')
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localRole.name),
      callback: function($$v) {
        _vm.$set(_vm.localRole, "name", $$v)
      },
      expression: "localRole.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên hiển thị"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên hiển thị"
    },
    model: {
      value: (_vm.localRole.display_name),
      callback: function($$v) {
        _vm.$set(_vm.localRole, "display_name", $$v)
      },
      expression: "localRole.display_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mô tả"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Mô tả"
    },
    model: {
      value: (_vm.localRole.description),
      callback: function($$v) {
        _vm.$set(_vm.localRole, "description", $$v)
      },
      expression: "localRole.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tìm kiếm user"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Nhập tên...",
      "remote-method": _vm.selectAdmin,
      "loading": _vm.fetchAdmin
    },
    on: {
      "change": _vm.selectSuggettionAdmin
    },
    model: {
      value: (_vm.suggettionAdmin),
      callback: function($$v) {
        _vm.suggettionAdmin = $$v
      },
      expression: "suggettionAdmin"
    }
  }, _vm._l((_vm.listAdmins), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left text-gray"
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" " + _vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "pull-right text-violet"
    }, [_c('i', {
      staticClass: "fa fa-phone"
    }), _vm._v(" " + _vm._s(item.phone))])])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Danh sách users"
    }
  }, _vm._l((_vm.selectedAdmins), function(admin) {
    return _c('el-tag', {
      key: admin.id,
      staticClass: "margin-sm-right",
      attrs: {
        "closable": true,
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.removeAdmin(admin)
        }
      }
    }, [_vm._v("\n          " + _vm._s(admin.name) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Permissions"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20,
      "offset": 2
    }
  }, [_c('ul', _vm._l((_vm.permissions), function(gpermission, key, index) {
    return _c('li', {
      key: key
    }, [_c('p', {
      staticClass: "text-blue text-bold"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('ul', {
      staticClass: "permission-subtree"
    }, _vm._l((gpermission), function(permission) {
      return (_vm.fetchData) ? _c('li', {
        key: key
      }, [_c('el-checkbox', {
        attrs: {
          "checked": _vm.checkIsExist(permission)
        },
        on: {
          "change": function($event) {
            return _vm.selectPermission($event, permission)
          }
        }
      }, [_vm._v(_vm._s(permission.display_name))])], 1) : _vm._e()
    }), 0)])
  }), 0)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Lưu lại")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62dbde07"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/role/EditRole.vue
// module id = 645
// module chunks = 1